import { ChangeDetectorRef, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { OperatorEnum } from '../../ui/OperatorUtil';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-condition-query-input-type',
  templateUrl: './condition-query-input-type.component.html',
  styleUrl: './condition-query-input-type.component.scss'
})
export class ConditionQueryInputTypeComponent extends FieldType {

  isChecked: boolean = false;
  style: any = {'height': '37.6px'};
  isfreetext: boolean = false;
  isPaste: boolean = false;
  text: string = "";
  modalRef!: BsModalRef;

  ngOnInit(): void {
    if(this.formControl.value){
      this.isChecked = true;
    }else{
      this.isChecked = false;
    }
  }

  onCheckboxChange(event: Event){
    const input = event.target as HTMLInputElement;
    this.isChecked = input.checked;
    if(!this.isChecked){
      this.formControl.setValue(undefined);
    }else{
      if(!this.formControl.value){
        this.isChecked = false;
        input.checked = false;
      }
    }
  }
constructor(private modalService: BsModalService,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }


  onInputChange() {
    if (this.formControl.value) {
      this.isChecked = true;
      this.props['isModified'] = true;
      if (!this.modalRef || this.modalRef.content.selectedCode != this.formControl.value) {
        this.text = "";
        this.props["defaultValue"] = "";
      }
    } else {
      this.isChecked = false;
      this.text = "";
      this.props['isModified'] = false;
      this.props['conditionType'] = "";
      this.props['defaultValue'] = this.formControl.value;
    }
    this.manageConditionType();
  }

  

  private manageConditionType() {
      if (this.formControl.value) {
          if (typeof this.formControl.value == 'string' && this.formControl.value.includes('|')) {
              const values =  this.formControl.value.split('|').map(v => v.trim());
              if (values.length > 1 && values.every(v => v.length > 0)) {
                this.props['conditionType'] = OperatorEnum.OperatorIn;
              } else if (!this.isfreetext) {
                this.props['conditionType'] = OperatorEnum.OperatorEqual
              } else {
                 this.props['conditionType'] = OperatorEnum.OperatorContain
              }
          } else if (!this.isfreetext || this.isPaste) {
              this.isPaste = !this.isPaste;
              this.props['conditionType'] = OperatorEnum.OperatorEqual
          } else {
              this.props['conditionType'] = OperatorEnum.OperatorContain;
          } 
      }
    }
    
}


